<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-4">
                            <form class="form-group" v-on:submit.prevent="findCardData">
                                <label>شماره کارت</label>
                                <div class="input-group">
                                    <input type="tel" class="form-control text-center" v-mask="'####-####-####-####'" v-model="pan" dir="ltr" style="direction: ltr !important">
                                    <span class="input-group-btn" v-if="pan && pan.replace(/-/g,'').length == 16"><button class="btn ripple btn-info" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                                </div>
                            </form>
                        </div>
                        <div class="col-md-12 mb-3" v-if="Object.keys(cardData).length">
                            <hr>
                        </div>
                        <div class="col-md-12" v-if="Object.keys(cardData).length">
                            <table class="table table-bordered table-hover user-details-table">
                                <tbody>
                                    <tr>
                                        <td>نام و نام خانوادگی صاحب کارت:</td>
                                        <td>{{ cardData.firstName + ' ' + cardData.lastName }}</td>
                                        <td>شماره همراه:</td>
                                        <td dir="ltr">{{ cardData.mobileNumber }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-12" v-if="Object.keys(cardData).length && cardData.canChangePin">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>نوع رمز</label>
                                        <select class="form-control" v-model="pinType">
                                            <option selected disabled value="">انتخاب کنید</option>
                                            <option value="1">رمز اول</option>
                                            <option value="2">رمز دوم</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-10">
                                    <button class="btn btn-success" style="margin-top: 29px;" :disabled="!pinType" @click="submit">ثبت و دریافت رمز</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardPassword',
    data(){
        return {
            resultFile: '',
            cardData: {},
            showLoading: false,
            nationalCode: '',
            legalCustomerDetails: {},
            pan: '505785',
            pinType: '',
            otp: '',
            session: '',
            customerId: 0
        }
    },
    methods: {
        findCardData(){
            this.showLoading = true;
            const postedData = {
                cardNumber: this.pan.toString().replace(/-/g,'')
            }
            this.$api.post('Organizations/Switch/Card/OwnerInfo',postedData).then(({data}) => {                
                if(data.status){
                    this.cardData = data.result;
                    if(!data.result.canChangePin){
                        this.$swal({
                            title: 'خطا',
                            icon: 'error',
                            text: 'تغییر رمز این کارت به علت عدم ثبت صحیح شماره همراه دارنده کارت امکان پذیر نمی باشد',
                            confirmButtonText: 'متوجه شدم'
                        });
                    }
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        submit(){
            this.showLoading = true;
            const postedData = {
                cardNumber: this.pan.toString().replace(/-/g,''),
                pinType: this.pinType == 1 ? 0 : 1
            };
            this.$api.post('Organizations/Switch/Card/ChangePin',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: `رمز ${this.pinType == 1 ? 'اول' : 'دوم'} کارت با موفقیت به تغییر کرد`,
                        confirmButtonText: 'متوجه شدم'
                    });
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        submitOtpCode(){
            this.showLoading = true;
            const postedData = {
                session: this.session,
                token: this.otp
            };
            this.$api.post('Pin/GetPin',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'رمز کارت با موفقیت به شماره همراه دارنده کارت ارسال شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.session = '';
                    this.otp = '';
                    this.pan = '505785';
                    this.nationalCode = '';
                    this.cardData = {};
                    this.legalCustomerDetails = {};
                    this.customerId = 0;
                }
            }).finally(() => {
                this.showLoading = false;
            });
        }
    }
}
</script>